import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms"
import { Dav } from "../../../dav/shared/dav"
import { Client } from "../../../shared/client/client"
import { Site } from "../../../dav/shared/site"

export function minElementValidator(countNb: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const hasEnough = control.value instanceof Array && control.value.length > countNb
        return hasEnough ? null : { 'minElement': { value: control.value } }
    }
}

export class DavForm extends FormGroup {

    constructor() {
        super({
            'adresse_serveur': new FormControl<string>("", [
                Validators.required,
                Validators.pattern('s?ftp://([0-9]{1,3}.){3}([0-9]{1,3})')
            ]),
            'login': new FormControl<string>("", [
                Validators.required
            ]),
            'password': new FormControl<string>("", [
                Validators.required
            ]),
            'nom': new FormControl<string>("", [
                Validators.required
            ]),
            'partenaire': new FormControl<string>("", []),
            'site': new FormControl<Site>(undefined, [
                Validators.required
            ]),
            'clients': new FormControl<Array<Client>>(new Array<Client>(), [
                minElementValidator(0)
            ])
        })
    }

    removeClients() {
        this.get("clients").setValue(new Array<Client>())
    }

    filterPredicate(client: Client, filter: string, data: Array<Client>, davId: string): boolean {
        return this.get('clients').value == null || !this.get('clients').value.some((c: Client, index: number, arr: Client[]): boolean => {
            return c.id === client.id
        }) && client != null && (client.code_client + " " + client.code_service + " " + client.raison_sociale).toUpperCase().includes(filter.trim().toUpperCase())
            && (!("dav" in client) || (!data.includes(client) && client["dav"]["id"] == davId))
    }

    selectClient(client: Client) {
        if (!this.get('clients').value.includes(client)) {
            this.get('clients').setValue(this.get('clients').value.concat(new Array<Client>(client)))
        }
    }

    unselectClient(client: Client) {
        this.get('clients').setValue(this.get('clients').value.filter(curr => client != curr))
    }

    patchValue(dav: Dav) {
        super.patchValue({
            'adresse_serveur': dav.adresse_serveur,
            'login': dav.login,
            'password': dav.password,
            'nom': dav.nom,
            'partenaire': dav.partenaire,
            'clients': dav.clients != undefined ? dav.clients : new Array<Client>(),
            'site': dav.site
        })
    }

}
